import { shrpaApi } from "./axios";

// Types
import { UsernameValidationResult } from "@contracts/userProfile";

export default {
  async validateUsername(authNameId: string, username: string): Promise<UsernameValidationResult> {
    const query = `?username=${username}`;
    const uri = `/profile/${authNameId}/validate-username`;
    const { data } = await shrpaApi.get<UsernameValidationResult>(uri + query);

    return data;
  },

  async updateUserName(authNameId: string, newUsername: string): Promise<boolean> {
    const query = `?newUsername=${newUsername}`;
    const uri = `/profile/${authNameId}/username`;
    const { data } = await shrpaApi.put<boolean>(uri + query);

    return data;
  },
};
